import { Pipe, PipeTransform } from "@angular/core";
import { TokenStorageService } from "src/app/core/auth/token-storage.service";

@Pipe({
  name: "checkIfViewOnly",
  pure: true
})
export class CheckIfViewOnlyPipe implements PipeTransform {

  constructor(private tokenStorage: TokenStorageService) {}

  transform(viewType: string, action: "tooltip" | "disable"): string | boolean {
    const authorities = this.tokenStorage.getAuthorities();
    const hasPermission = authorities?.includes(viewType);

    if (hasPermission) {
      if (action === "tooltip") {
        return "You don't have permission to perform this action.";
      }
      if (action === "disable") {
        return true;
      }
    }

    return false;
  }
}
